export default __webpack_public_path__ + "static/media/twitterOnboarding.c01b0b0a.svg";